import * as React from 'react';

import classNames from 'classnames';
import _uniqueId from 'lodash/uniqueId';

/* eslint-disable react/no-string-refs, */
import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import { stringKeyToTuple } from 'js/lib/stringKeyTuple';

import { VisuallyHidden } from '@coursera/cds-core';

import { CMLUtils } from 'bundles/cml';
import ForumsCmlEditor from 'bundles/discussions/components/ForumsCmlEditor';
import ReplyFollow from 'bundles/discussions/components/repliesList/ReplyFollow';
import { DTD_NAME, savingStates } from 'bundles/discussions/constants';
import DiscussionsCMLUtils from 'bundles/discussions/utils/DiscussionsCMLUtils';
import generateReplyData from 'bundles/discussions/utils/generateReplyData';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import GroupForumsV1 from 'bundles/naptimejs/resources/groupForums.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import OnDemandCourseForumsV1 from 'bundles/naptimejs/resources/onDemandCourseForums.v1';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import OnDemandMentorForumsV1 from 'bundles/naptimejs/resources/onDemandMentorForums.v1';
import TrackedButton from 'bundles/page/components/TrackedButton';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/ReplyCMLInput';

class ReplyCMLInput extends React.Component {
  static propTypes = {
    parentPost: PropTypes.object.isRequired,
    savingState: PropTypes.string.isRequired,
    shouldFocusCounter: PropTypes.number,
    placeholder: PropTypes.string,
    ariaLabel: PropTypes.string,
    ariaDescribedBy: PropTypes.string,
    currentForum: PropTypes.oneOfType([
      PropTypes.instanceOf(OnDemandCourseForumsV1),
      PropTypes.instanceOf(OnDemandMentorForumsV1),
      PropTypes.instanceOf(GroupForumsV1),
    ]),
    forumType: PropTypes.string,
    courseId: PropTypes.string,
    contextId: PropTypes.string,
    question: PropTypes.object,
    hideFollow: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof ReplyCMLInput.contextTypes>;

  static defaultProps = {
    get placeholder() {
      return _t('Enter your reply here');
    },
    savingState: savingStates.UNCHANGED,
  };

  constructor(props: $TSFixMe, context: $TSFixMe) {
    super(props, context);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'replyButtonId' does not exist on type 'R... Remove this comment to see the full error message
    this.replyButtonId = _uniqueId('thread_reply_button_');
    this.state = this.getDefaultState();
  }

  componentWillReceiveProps(nextProps: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'savingState' does not exist on type 'Rea... Remove this comment to see the full error message
    if (nextProps.savingState !== this.props.savingState) {
      if (nextProps.savingState === savingStates.SAVED) {
        this.setState((prevState) => {
          return Object.assign(this.getDefaultState(), {
            // @ts-expect-error ts-migrate(2339) FIXME: Property 'editorKey' does not exist on type 'Reado... Remove this comment to see the full error message
            editorKey: prevState.editorKey + 1,
            announceSubmitSuccessNotification: true,
          });
        });
      } else if (nextProps.savingState === savingStates.ERROR) {
        this.handleSaveError();
      } else if (nextProps.savingState === savingStates.INVALID_TERM_ERROR) {
        this.handleInvalidTermError();
      } else if (nextProps.savingState === savingStates.RATE_LIMIT_ERROR) {
        this.handleRateLimitError();
      } else if (nextProps.savingState === savingStates.USER_BLOCKED_ERROR) {
        this.handleBlockedUserError();
      }
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'announceSubmitSuccessNotification' does not exist on type 'Rea... Remove this comment to see the full error message
    } else if (this.state.announceSubmitSuccessNotification) {
      this.setState({
        announceSubmitSuccessNotification: false,
      });
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'shouldFocusCounter' does not exist on ty... Remove this comment to see the full error message
    if (this.props.shouldFocusCounter < nextProps.shouldFocusCounter) {
      this.setFocus();
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isFollowing' does not exist on type 'Rea... Remove this comment to see the full error message
    if (nextProps.question && nextProps.question.isFollowing !== this.state.isFollowing) {
      this.setState({ isFollowing: nextProps.question.isFollowing });
    }
  }

  handleSaveError() {
    this.setState({
      saveError: true,
      saveErrorMessage: _t('Something went wrong. Please reload the page and try again.'),
    });
  }

  handleInvalidTermError() {
    this.setState({
      saveError: true,
      saveErrorMessage: _t(
        'There is something wrong with your post. Please review and edit it or contact support for assistance.'
      ),
    });
  }

  handleBlockedUserError() {
    this.setState({
      saveError: true,
      saveErrorMessage: _t(
        'You are currently blocked from creating forum posts. Please contact support for assistance.'
      ),
    });
  }

  handleRateLimitError() {
    this.setState({
      saveError: true,
      saveErrorMessage: _t('You have created too many posts in a short time period. Please wait before trying again'),
    });
  }

  getDefaultState() {
    // Always show the toolbar unless this is a comment.
    const disabledPlugins: $TSFixMe = [];
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'question' does not exist on type 'Readon... Remove this comment to see the full error message
    const { question } = this.props;

    return {
      cml: CMLUtils.create('', DTD_NAME),
      hasErrors: false,
      submitEnabled: false,
      disabledPlugins,
      focus: false,
      editorKey: 1,
      isFollowing: question && question.isFollowing,
      firstFocus: false,
      announceSubmitSuccessNotification: false,
      saveErrorMessage: '',
      saveError: false,
    };
  }

  setFocus = () => {
    this.setState({ isFocused: true });

    if (typeof window !== 'undefined') {
      // manually set focus on the reply editor at the bottom of the page.
      // this is very temporary until we use forumsV2 which moves the reply container
      // right below the button and we don't need this focus
      // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
      document.querySelector('.reply-container .rc-ReplyCML .editor-container div[data-slate-editor="true"]').focus();
    }
  };

  removeFocus = () => {
    this.setState({ isFocused: false });
  };

  // this additional state variable is required to initially hide the Reply Follow component
  // and only after first focus, determine if it should be shown or not.
  handleFirstFocus = () => {
    this.setState({ firstFocus: true });
  };

  handleInputChange = (cml: $TSFixMe) => {
    const hasErrors = !DiscussionsCMLUtils.validateLength(cml);
    const submitEnabled = true;

    this.setState({ cml, hasErrors, submitEnabled, announceSubmitSuccessNotification: false });
  };

  handleSubmitSuccess = () => {
    this.setState({
      submitEnabled: false,
      announceSubmitSuccessNotification: true,
      cml: CMLUtils.create('', DTD_NAME),
    });
  };

  handleSubmit = () => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'cml' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
    const { cml, isFollowing, hasErrors } = this.state;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'parentPost' does not exist on type 'Read... Remove this comment to see the full error message
    const { parentPost, contextId, currentForum, question } = this.props;

    if (hasErrors) {
      this.setFocus();
      return;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumType' does not exist on type 'Reado... Remove this comment to see the full error message
    const forumType = (currentForum && currentForum.forumType.typeName) || this.props.forumType;
    const options = generateReplyData(parentPost, contextId, cml, forumType, isFollowing);

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'handleSubmit' does not exist on type 'Re... Remove this comment to see the full error message
    this.props.handleSubmit({
      options,
      question,
      parentPost,
      forumType,
      isFollowing,
      onSuccess: this.handleSubmitSuccess,
    });
  };

  handleFollow = (isFollowing: $TSFixMe) => {
    this.setState({ isFollowing });
  };

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'parentPost' does not exist on type 'Read... Remove this comment to see the full error message
    const { parentPost, question, courseId, placeholder, ariaLabel, ariaDescribedBy, hideFollow } = this.props;
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'cml' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
      cml,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'firstFocus' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
      firstFocus,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isFollowing' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
      isFollowing,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'editorKey' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
      editorKey,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'submitEnabled' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
      submitEnabled,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'hasErrors' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
      hasErrors,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'announceSubmitSuccessNotification' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
      announceSubmitSuccessNotification,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'saveError' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
      saveError,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'saveErrorMessage' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
      saveErrorMessage,
    } = this.state;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'replyButtonId' does not exist on type 'R... Remove this comment to see the full error message
    const replyButtonId = this.replyButtonId;

    const contentLengthWarning = DiscussionsCMLUtils.generateContentLengthWarning(cml);

    const submitError = <div className="c-error-text c-form-error-message">{saveErrorMessage}</div>;

    const classes = classNames('rc-ReplyCML', 'flex-1');
    const questionIdParts = stringKeyToTuple(parentPost.questionId || '');
    const questionId = questionIdParts[questionIdParts.length - 1];
    const imageUploadOptions = DiscussionsCMLUtils.getImageUploadOptions(courseId, questionId);

    return (
      <div className={classes}>
        <div className="rc-ReplyCML__editor-label body-1-text" aria-hidden={true}>
          <strong>{_t('Your Reply')}</strong>
        </div>
        <div className="editor-container">
          <ForumsCmlEditor
            cml={cml}
            key={editorKey}
            placeholder={placeholder}
            imageUploadOptions={imageUploadOptions}
            ariaLabel={ariaLabel || _t('Your Reply')}
            ariaDescribedBy={ariaDescribedBy}
            onChange={this.handleInputChange}
            onFocus={this.handleFirstFocus}
            onBlur={this.removeFocus}
            focusOnLoad={false}
          />
        </div>

        {!!contentLengthWarning && (
          <div className="horizontal-box align-items-right" style={{ marginBottom: 20 }}>
            {contentLengthWarning}
          </div>
        )}

        {saveError && (
          <div className="horizontal-box align-items-right" style={{ marginBottom: 20 }}>
            {submitError}
          </div>
        )}

        <div className="horizontal-box align-items-right align-items-vertical-center">
          <div className="flex-1">
            {firstFocus && !hideFollow && question && (
              <ReplyFollow checked={isFollowing} onChange={this.handleFollow} />
            )}
          </div>
          <VisuallyHidden role="status" component="span" className="rc-A11yScreenReaderOnly">
            {announceSubmitSuccessNotification && _t('Reply posted successfully.')}
          </VisuallyHidden>
          <TrackedButton
            id={replyButtonId}
            ref="submit"
            className="secondary"
            onClick={this.handleSubmit}
            trackingName="thread_reply"
            disabled={!submitEnabled || hasErrors}
          >
            {_t('Reply')}
          </TrackedButton>
        </div>
      </div>
    );
  }
}

export default ReplyCMLInput;
